import { ApiConfig } from './api';
import { fetchWrapper, objectToSearchParams } from './utils/http-utils';
import { Organization, OrganizationFeatures } from '../types/organization';
import { User, UserDraft } from '../types/user';

export const login =
  (config: ApiConfig) =>
  (data: {
    email: string;
    password: string;
    organization_subdomain?: string;
  }): Promise<{ auth: boolean; detail?: string }> =>
    fetchWrapper<{ auth: boolean; detail?: string }>(
      `${config.endpoint}login`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );

export const getSession = (config: ApiConfig) => (): Promise<User & { organization: Organization }> =>
  fetchWrapper<User & { organization: Organization }>(
    `${config.endpoint}auth/verify`,
    {
      method: 'POST',
    },
    config
  );

export const logout = (config: ApiConfig) => (): Promise<any> =>
  fetchWrapper(
    `${config.endpoint}logout`,
    {
      method: 'GET',
    },
    config
  );

export const register =
  (config: ApiConfig) =>
  (data: {
    admin_name: string;
    admin_email: string;
    registration_secret: string;
    organization_subdomain: string;
    organization_name: string;
  }): Promise<UserDraft> =>
    fetchWrapper<UserDraft>(
      `${config.endpoint}register`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );

export const passwordReset =
  (config: ApiConfig) =>
  (
    data: { new_password?: string; email?: string; organization_subdomain?: string },
    resetToken: string | null = null
  ): Promise<{ success: boolean }> => {
    const url = resetToken
      ? `${config.endpoint}auth/password-reset?reset_token=${resetToken}`
      : `${config.endpoint}auth/password-reset`;

    return fetchWrapper<{ success: boolean }>(
      url,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );
  };

export const serviceLogin =
  (config: ApiConfig) =>
  (service: string, external = false, organization_subdomain?: string): Promise<{ uri: string }> => {
    let url = `${config.endpoint}${external ? 'external-' : ''}${service}-login`;
    if (organization_subdomain) {
      const searchParams = objectToSearchParams({
        query_organization_subdomain: organization_subdomain,
      });
      url += `?${searchParams}`;
    }

    return fetchWrapper<{ uri: string }>(
      url,
      {
        method: 'GET',
      },
      config
    );
  };

export const publicFeatures =
  (config: ApiConfig) =>
  (organization_subdomain?: string): Promise<OrganizationFeatures> => {
    let url = `${config.endpoint}public_features`;
    if (organization_subdomain) {
      const searchParams = objectToSearchParams({ query_organization_subdomain: organization_subdomain });
      url += `?${searchParams}`;
    }

    return fetchWrapper<OrganizationFeatures>(
      url,
      {
        method: 'GET',
      },
      config
    );
  };
